const doc = [({"ko":({"constantBookingErrorCode":({"no_data":"예약 데이터를 검색할 수 없습니다.", "unknown":"알 수 없는 오류가 발생했습니다."})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;